/* global axios */
import ApiClient from '../ApiClient';

class DiscountCodesAPI extends ApiClient {
  constructor() {
    super('planning/discount-codes', { accountScoped: true });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, { discount_code: payload });
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, { discount_code: payload });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new DiscountCodesAPI();
